import type { Quiz } from "@vita-learning/types";

export const QUIZ_SOURCES: Quiz["source"][] = ["file", "note", "url"];
